/**
 * Centralized localStorage key constants.
 * Prevents typos and makes it easy to find all storage usage.
 */

// Auth & identity
export const SK_JWT = 'careweave_jwt';
export const SK_PRIVACY_ICON = 'careweave-privacy-icon';

// Profile & prep
export const SK_PREP_PROFILE = 'careweave_prep_profile';
export const SK_PREP_CONTACTS = 'careweave_prep_contacts';
export const SK_PREP_PACK = 'careweave_prep_pack';

// Crisis
export const SK_CRISIS_CHECKED = 'careweave_crisis_checked';
export const SK_CRISIS_PLAN_STAGES = 'careweave_crisis_plan_stages';
export const SK_LAST_CRISIS_DATE = 'careweave_lastCrisisDate';
export const SK_CRISIS_NOTE_DISMISSED = 'cw_crisis_note_dismissed';

// Tools
export const SK_STARRED_TOOLS = 'careweave_starred_tools';
export const SK_TOOL_ACCESS_COUNTS = 'careweave_tool_access_counts';

// Journeys
export const SK_ACTIVE_JOURNEYS = 'careweave_active_journeys';
export const SK_COMPLETED_JOURNEY_RESOURCES = 'careweave_completed_journey_resources';

// Check-ins
export const SK_CHECKINS = 'careweave_checkins';
export const SK_ENABLED_CHECKIN_QUESTIONS = 'careweave_enabled_checkin_questions';
export const SK_SEEN_CHECKIN_INTRO = 'cw_seen_checkin_intro';
export const SK_SEEN_ED_CHECKIN = 'cw_seen_ed_checkin';

// Demo data
export const SK_DEMO_PROFILES = 'careweave_demo_profiles';

// Widgets & UI
export const SK_WIDGET_ORDER = 'careweave_widget_order';
export const SK_WIDGET_VISIBLE = 'careweave_widget_visible';
export const SK_HIDE_PATTERNS = 'careweave_hide_patterns';
export const SK_DARK_MODE = 'careweave_dark_mode';
export const SK_ACCESSIBILITY = 'careweave_accessibility';
export const SK_ESSENTIALS_MODE = 'careweave_essentials_mode';
export const SK_ESSENTIALS_TOOLS = 'careweave_essentials_tools';

// XP & gamification
export const SK_XP = 'careweave_xp';
export const SK_JOURNAL_ENTRIES = 'cw_journal_entries';
export const SK_XP_REWARDED = 'careweave_xp_rewarded';

// Event logs
export const SK_EVENT_LOGS = 'careweave_event_logs';

// Offline queue
export const SK_OFFLINE_QUEUE = 'careweave_offline_queue';

// Medications
export const SK_MEDICATIONS = 'careweave_medications';
export const SK_MED_LOGS = 'careweave_med_logs';

// ED (Emergency Department)
export const SK_ED_HISTORY = 'careweave_ed_history';

// Flare forecast
export const SK_FLARE_LOCATION = 'cw_flare_location';

// Goals
export const SK_ACTIVE_GOALS = 'careweave_active_goals';
export const SK_GOALS_XP_AWARDED = 'careweave_goals_xp_awarded';

// Tutorials & tips (dynamic key helpers)
export const SK_JOURNEY_TUTORIAL = 'journeyTutorialSeen';

/** Returns storage key for a check-in draft for a given date string */
export function checkinDraftKey(dateStr: string): string {
  return `cw_draft_checkin_${dateStr}`;
}

/** Returns storage key for a feature tip */
export function featureTipKey(tipKey: string): string {
  return `cw_tip_${tipKey}`;
}

/** Returns storage key for a module intro */
export function moduleIntroKey(moduleKey: string): string {
  return `cw_seen_${moduleKey}`;
}

// ── Stigma Tracker (2026-05-14 redesign) ──────────────────────────────
export const SK_STIGMA_TRACKER_DRAFTS = 'cw_stigma_tracker_drafts_v1';
export const SK_STIGMA_TRACKER_ENTRY_MODE = 'cw_stigma_tracker_entry_mode';
export const SK_STIGMA_TRACKER_CURRENT = 'cw_stigma_tracker_current_v1';
export const SK_RETURN_PROMPT_OPTIN = 'cw_stigma_tracker_return_prompt_optin';
export const SK_RETURN_PROMPT_DISMISSED_SESSION = 'cw_stigma_tracker_return_prompt_dismissed_session';
export const SK_STIGMA_REFLECTIONS_COLLAPSED = 'cw_stigma_reflections_collapsed';
